// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N1lg","colBig":"styles_colBig__1u10P","colSmall":"styles_colSmall__1jaqF","shopifyNameWrapper":"styles_shopifyNameWrapper__1QVz4"};